<template>
  <div>
    <div v-if="fjs12 && fjs12.length">
      <div class="row" style="border: 1px solid #e0e0e0">
        <div class="d-flex col-12 justify-content-between px-3 py-2" style="background-color: #f8f8fb;">
          <div><h5 class="text-list-fjs12 mb-1">履歴照会</h5></div>
        </div>
        <div class="p-0">
          <Spliter :initialLeftWidth="260">
            <template #left>
              <div class="col-12 px-1">
                <div class="mt-2 px-1">
                  <b-button class="w-lg btn-edit" :disabled="listIds.length === 0" :class="{'bg-disabled': listIds.length === 0}" @click="exportExcel()">Excel出力</b-button>
                </div>
                <div class="table-responsive mt-2 mb-0 scroll" :style="{maxHeight: isExpand ? '60vh': '50vh'}">
                  <vue-loadmore :on-refresh="onRefresh" :on-loadmore="onLoad" loading-text="読み込み中" :finished="finished" finished-text=" ">
                    <table class="table align-middle mb-0" id="table">
                      <tbody>
                        <tr id="tr" v-for="(history, index) in fjs12" :key="index"
                          @click="getAnswersId(history.id), (clickIndex = index)" style="cursor: pointer">
                          <td :class="{ 'bg-active-locomo': index === clickIndex }" class="pe-1">
                            <input class="form-check-input" type="checkbox" @click="checkedLocomo(history.id)"
                              id="formCheckRight2" :checked="isChecked(history.id)" style="font-size: 24px; margin: 0;" />
                          </td>
                          <td width="50%" class="px-1" :class="{ 'bg-active-locomo': index === clickIndex }">
                            <h5 class="text-list-fjs12 mb-0">
                              {{ history.created_at | fomatDate2 }}
                            </h5>
                          </td>
                          <td width="50%" class="px-2" :class="{ 'bg-active-locomo': index === clickIndex }" style="min-width: 110px">
                            <h5 class="text-list-fjs12 mb-0 text-right">
                              {{ history ? history.total_score : "" }}/ 100
                              {{ $t("menuitems.hospital.points") }}
                            </h5>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </vue-loadmore>
                </div>
              </div>
            </template>

            <template #right>
              <div class="col-12 px-3">
                <div class="card-title mt-2 d-flex justify-content-between">
                  <h5 class="text-list-fjs12">
                    {{ $t("menuitems.hospital.detail") }}
                  </h5>
                  <div>
                    <button v-if="edit" class="w-lg btn-cancel" @click="cancel">
                      キャンセル
                    </button>
                    <button v-if="(role === 'admin' && !edit) || (role === 'hospital' && !edit && time_out_facility === null)" class="w-lg btn-edit" @click="toEdit">
                      編集
                    </button>
                    <button v-if="['admin', 'hospital'].includes(role) && edit" class="w-lg btn-edit" @click="editFjs12">
                      保存
                    </button>
                  </div>
                </div>
                <div class="color-level" v-for="(history, index) in fjs12" :key="index">
                  <h5 v-if="index == clickIndex" id="colorFilter" class="my-3"></h5>
                </div>
                <div class="scroll" v-if="tempAnswer.length > 0" style="margin-bottom: 20px;" :style="{maxHeight: isExpand ? '60vh': '50vh'}">
                  <div class="m-2" v-for="(question, index) in tempAnswer" :key="index">
                    <h6 class="text-answers">
                      {{ index + 1 }} . {{ question ? question.description : "" }}
                      {{ getQuestionText(question.discomfort_question_id) }}
                    </h6>
                    <span v-for="(label, key) in answerList" :key="key" class="form-radio-outline form-radio-success"
                      style="display: inline-block;">
                      <input class="form-check-input mt-2" size="lg"
                        style="margin-right: 1em; -webkit-transform: scale(1.5)" type="radio" :id="'answer' + index + key"
                        :value="key" v-model="question.answer" :checked="question.answer === parseInt(key)"
                        :disabled="!edit" />
                      <label class="label-answers" :for="'answer' + index + key" style="margin-right: 1em"
                        :class="{ 'text-muted': question.answer == parseInt(key) }">
                        {{ label }}
                      </label>
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </Spliter>
        </div>
      </div>
    </div>

    <div v-else class="undefine">
      <img src="@/assets/images/no-data.jpg" alt="" />
      <div class="mt-3">詳細データはありません。</div>
    </div>
  </div>
</template>

<script>
import { filter } from "../../helpers/Vue-Filter";
import { hospitalMethods } from "@/state/helpers";
import { hospitalComputed } from "@/state/helpers";
import { getProfile } from "../../helpers/Auth";
import api from "@/api";
import moment from 'moment';
import Spliter from "./spliter.vue";

export default {
  filters: {
    ...filter,
  },
  components: {Spliter},
  props: ["fjs12", "dataQuestionsFjs12", "pagination", "time_out_facility", "userInfor", "isExpand"],
  data() {
    return {
      clickIndex: 0,
      idEdit: 0,
      resultAnswer: [],
      enabledExportPDF: false,
      flagPDFAll: false,
      role: getProfile().role.name,
      tempAnswer: [],
      locomoQuestions: [],
      edit: false,
      page: 1,
      finished: false,
      answerList: {
        0: '全く気にならない',
        1: 'ほとんど気にならない',
        2: '時々気になる',
        3: '良く気になる',
        4: 'ほぼいつも気になる',
      },
      listIds: [],
    };
  },

  async created() {
    await this.getQuestionsUser(this.role).then((res) => {
      this.locomoQuestions = res;
    });

    if (!this.fjs12 || this.fjs12.length == 0) {
      return;
    } else {
      this.getAnswersId(this.fjs12[0].id);
    }
  },

  computed: {
    ...hospitalComputed,
  },

  watch: {
    clickIndex(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.cancel();
      }
    }
  },

  methods: {
    ...hospitalMethods,

    onRefresh(done) {
      this.page = this.page;
      this.finished = false;
      this.fetchPage();

      done();
    },

    onLoad(done) {
      if (this.page < this.pagination.last_page) {
        this.loadMore();
      } else {
        // all data loaded
        this.finished = true;
      }
      done();
    },

    loadMore() {
      this.$emit("loadMoreFjs12");
      this.page++;
    },

    async getAnswersId(index) {
      try {
        const res = await api.detailSurveyFjs12(index);
        if (res.status == 200) {
          this.tempAnswer = res.data
          this.resultAnswer = JSON.parse(JSON.stringify(this.tempAnswer));
        }
        this.idEdit = index;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },

    getQuestionText(id) {
      const question = this.dataQuestionsFjs12.find(item => item.id === id);
      return question ? question.question : "";
    },

    exportExcel() {
      const payload = {};
      payload.ids = this.listIds.toString();
      try {
        const formattedDate = moment().format('YYYYMMDD');
        api.exportHistory('discomfort', payload, `股関節の違和感チェック_${this.userInfor.mobile}_${this.userInfor.patient_id}_${formattedDate}`);
      } catch (error) {
        console.log(error);
      }
    },

    toEdit() {
      this.edit = true;
    },

    async editFjs12() {
      try {
        if (this.edit) {
          const answer = JSON.parse(JSON.stringify(this.tempAnswer));
          const respon = await api.updateSurveyFjs12(answer, this.idEdit);
          if (respon.status == 200) {
            this.edit = !this.edit;
            window.toastr.success("編集に成功しました");
            this.$emit('reloadFjs12');
          }
        }
      } catch (e) {
        console.log(e);
      }
    },

    cancel() {
      this.tempAnswer = JSON.parse(JSON.stringify(this.resultAnswer)) || [];
      this.edit = false;
    },

    checkedLocomo(id) {
      const index = this.listIds.findIndex(item => item === id);
      if (index >= 0) {
        this.listIds.splice(index, 1);
      } else {
        this.listIds.push(id);
      }
    },

    isChecked(id) {
      if (this.listIds.includes(id)) return true;
      return false;
    },
  },

};
</script>

<style lang="scss" scoped>
* {
  font-family: "Noto Sans JP";
}

.text-list-fjs12 {
  color: #404040;
  font-size: 16px;
  font-weight: 700;
}

.text-list-time {
  color: #404040;
  font-weight: 400;
  font-size: 14px;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #d3d3d3 !important;
  opacity: 1;
  /* Firefox */
}

::-webkit-input-placeholder {
  color: #d3d3d3 !important;
  opacity: 1;
  /* Firefox */
}

.text-table {
  color: #404040;
}

.text-answers {
  color: #404040;
  font-size: 16px;
}

.text-link {
  color: #336aff;
}

.bg-active-locomo {
  background: #b8e060;
}

.icon-locomo {
  color: #810d20;
}

.color-locomo {
  color: #404040 !important;
  font-size: 16px;
}

.color-level {
  font-weight: 700;
  font-size: 20px;
}

.label-answers {
  color: #b1adad;
  font-size: 16px;
}

.text-end {
  align-items: end;
}

// tbody { display: block; }

// tbody {
//   height: 250px;
//   overflow-y: auto;
//   overflow-x: hidden;
// }

.scroll {
  // max-height: 50vh;
  overflow-y: scroll;
}

/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.undefine {
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #404040;
}

::v-deep .form-radio-success .form-check-input:checked:after {
  background-color: #8fc31f !important;
  border-color: #8fc31f !important;
}

::v-deep .form-radio-success .form-check-input:checked {
  border-color: #8fc31f !important;
}

.select-all {
  overflow-y: scroll;
}

.text-right {
  text-align: right;
}

.btn-edit {
  color: white;
  background-color: #8fc31f;
  border: none;
  border-radius: 4px;
  padding: 5px;
  font-size: 14px;
  margin-left: 24px;
}

.btn-cancel {
  color: #ff5858;
  background-color: white;
  border: 1px solid #ff5858;
  border-radius: 4px;
  padding: 5px;
}

.bg-disabled {
  background: #ffffff !important;
  color: #d3d3d3 !important;
}
</style>
